import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import swal from 'sweetalert2';
import { CalculateNormalHourMultipiler, CalculateHolidayHourMultipiler } from '../const/constant';
import { getOvertimeBaseDate, getOvertimeMinutes } from './util/overtimeTime';
import { Link } from 'react-router-dom';
const ProxyOvertime = ({ editType, isShow, editInformation, onChangeFunc, saveFunc, toggleFunc}) => {
  //const [selectDate, setDate] = useState(editInformation.takeOfficeDate);
  const { id, startAt, endAt, reason, notes, payType, pay, isPartTime, hasRest} = editInformation;
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };
  const [dropReason, setDropReason] = useState('-1');

  const handleDropReason = (e) => {
    setDropReason(e.target.value)

  }
  // function handleSelectDateChange(momentDate) {
  //   console.log(momentDate.format('YYYY-MM-DD'))

  //   setDate(momentDate);
  // }

// 加班單不處理跨日，時數只算同一天的時分差，跟送出去的值一致
const overtimeMinutes = getOvertimeMinutes(editInformation);
var originTotalSec = (overtimeMinutes || 0) * 60;
var totalSec = originTotalSec;
if(hasRest && originTotalSec>=4*60*60){
  if(totalSec>= 8*60*60)
    totalSec -= 60*60;
  else if(totalSec>=4*60*60)
    totalSec -= 30*60;
}
var hours = parseInt(totalSec / 3600);
var minutes = parseInt(totalSec / 60) % 60;
var totalHours = (hours + (minutes/60)).toFixed(1);
var divider = pay < 1000 ? 1  : 240;

var restNotice = "大於等於4小時會扣0.5小時，大於等於8小時會扣1小時";


var result = totalSec > 0
  ? (hours < 10 ? "0" + hours : hours) + "小時" + (minutes < 10 ? "0" + minutes : minutes) + "分鐘"
  : '結束時間必須晚於開始時間';
  return (
    <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}>
      <div className="form-block" style={{minWidth: '400px'}}>
        <div className="u-small-title">{editType === 'ADD' ? '新增' : '編輯'}加班單</div>
        <form className="u-form">
        <div className="row">
            <div className="col-5 col-pad-12">
              <select className="u-form__select" style={{marginLeft:'5px',marginTop:'8px'}} value={dropReason} onChange={handleDropReason}>
              <option key="0"  disabled value="-1">請選擇</option>
              <option key="1" value="早班人力不足">早班人力不足</option>
              <option key="2" value="晚班人力不足">晚班人力不足</option>
              <option key="3" value="當日營運人力不足">當日營運人力不足</option>
              <option key="4" value="空班未休息">空班未休息</option>
              <option key="5" value="配合現場營運臨時加班換加班費">配合現場營運臨時加班換加班費</option>
              <option key="6" value="人力不足，加班換補休">人力不足，加班換補休</option>
              <option key="7" value="休假日加班">休假日加班</option>
              <option key="8" value="自助吧排班">自助吧排班</option>

              </select>
            </div>
          </div>
          <div className="row m-t-16">
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">事由：</label>
              <input required={true} value={reason} onChange={(e)=>{onChangeFunc('reason', e.target.value);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
            <div className="col-6 col-pad-12">
              <label className="u-form__label text-align-right">申請日期：{getOvertimeBaseDate(editInformation)}</label>
            </div>
          </div>
          <div className="row">
          <div className="col-6 col-pad-12">
              <div style={{ flex: '0 0 90px' }}>
                <span className="u-form__label text-align-right">開始時間：</span>
              </div>
              <DatePicker
                id="add_date_picker_selectDate"
                locale="zh-tw"
                showTimeSelect
                showTimeSelectOnly
                dateFormat="LT"
                timeCaption="Time"
                timeFormat="HH:mm"
                selected={startAt}
                onChange={(e)=>{
                  // 只比時分，日期一律以申請日期為準
                  if(!(getOvertimeMinutes({ startAt: e, endAt }) > 0))
                  {
                    swal({
                      type: 'error',
                      title: '開始時間不可大於結束時間',
                      showConfirmButton: false,
                      showCloseButton: true,
                      heightAuto: false,
                      width: '250px'
                    })
                    return
                  }  
                  
                  onChangeFunc('startAt', e);}}
                className="u-form__input"
                disabledKeyboardNavigation
                disableNativeKeyboard
                onKeyDown={(e) => {
                  e.preventDefault();
              }}
              />
            </div>
            <div className="col-6 col-pad-12">
              <div style={{ flex: '0 0 90px' }}>
                <span className="u-form__label text-align-right">結束時間：</span>
              </div>
              <DatePicker
                id="add_date_picker_selectDate"
                locale="zh-tw"
                showTimeSelect
                showTimeSelectOnly
                dateFormat="LT"
                timeCaption="Time"
                timeFormat="HH:mm"
                selected={endAt}
                onChange={(e)=>{
                  // 只比時分，日期一律以申請日期為準
                  if(!(getOvertimeMinutes({ startAt, endAt: e }) > 0))
                  {
                    swal({
                      type: 'error',
                      title: '結束時間不可小於開始時間',
                      showConfirmButton: false,
                      showCloseButton: true,
                      heightAuto: false,
                      width: '250px'
                    })
                    return
                  }  
                  onChangeFunc('endAt', e);
                }}
                className="u-form__input"
                disabledKeyboardNavigation
                disableNativeKeyboard
                onKeyDown={(e) => {
                  e.preventDefault();
              }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6 col-pad-12">
              <label className="u-form__label text-align-right">總時數(系統計算)：{result}</label>
            </div>
            
              {
                originTotalSec>=4*60*60 ?
                <div className="col-6 col-pad-12">
                  <input className='checkmark' key={12345} onChange={(e)=>{
                      onChangeFunc('hasRest', e.target.value);
                    }} type="checkbox" checked={hasRest} value={hasRest? 0 : 1} 
                  />
                  <span style={{fontSize:'18px', marginLeft:'20px'}}>
                    加班期間有休息<br/>({restNotice})
                  </span> 
                </div> : ''
              }

          </div>
          <div className="row">
            <div className="col-6 col-pad-12">
            <Link className="btn btn-md save" style={{color:'white'}} to={{ pathname: "https://drive.google.com/file/d/1EWlMTMh-PhK5U-QnsBI4TKVr9Fw6Lv-q/view?usp=drive_link" }} target="_blank">查詢加班費類別</Link>
          
            </div>
          </div>

            {
              isPartTime?<div className="row">

                <div className="col-5 col-pad-12">
                    <label className="u-form__label text-align-right">
                    <input
                    type="radio"
                    value="false"
                    checked={payType == '3'}
                    onChange={(e)=>{onChangeFunc('payType', '3');}}
                    /> 
                    休假日加班費:{((pay/divider) * CalculateHolidayHourMultipiler(totalHours)).toFixed(0)}元</label>
                </div>
            </div>:

              <div className="row">
                <div className="col-6 col-pad-12">
                    <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>
                      <input
                        type="radio"
                        value="false"
                        checked={payType == '1'}
                        onChange={(e)=>{onChangeFunc('payType', '1');}}
                        />                                
                      轉換補休時數：{totalHours} 小時
                      </label>
                </div>
                <div className="col-5 col-pad-12">
                    <label className="u-form__label text-align-right">
                    <input
                    type="radio"
                    value="false"
                    checked={payType == '3'}
                    onChange={(e)=>{onChangeFunc('payType', '3');}}
                    /> 
                    休假日加班費:{((pay/divider) * CalculateHolidayHourMultipiler(totalHours)).toFixed(0)}元</label>
                </div>
            </div>
            }
            <div className="row">
              
                  <div className="col-5 col-pad-12">
                    <label style={{ color: totalHours > 4? 'gray' : 'black'}} className="u-form__label text-align-right">
                    <input
                    
                    type="radio"
                    value="false"
                    checked={payType == '2'}
                    //勞動基準法第32條：雇主延長勞工之工作時間連同正常工作時間，一日不得超過12小時； by 0118 秋雲
                    disabled={totalHours >4}
                    
                    onChange={(e)=>{onChangeFunc('payType', '2');}}
                    /> 
                    加班費:{((pay/divider) * CalculateNormalHourMultipiler(totalHours)).toFixed(0)}元</label>
                </div>

                <div className="col-5 col-pad-12">
                    <label className="u-form__label text-align-right">
                    <input
                    type="radio"
                    value="false"
                    checked={payType == '4'}
                    onChange={(e)=>{onChangeFunc('payType', '4');}}
                    /> 
                    國定假日:{((pay/divider) * totalHours * 2).toFixed(0)}元</label>
                </div>
            </div>
            <div className="row">
                <div className="col-5 col-pad-12">
                    <label className="u-form__label text-align-right">
                    <input
                    type="radio"
                    value="false"
                    checked={payType == '5'}
                    onChange={(e)=>{onChangeFunc('payType', '5');}}
                    /> 
                    例假日加班:{((pay/divider) * totalHours * 2).toFixed(0)}元 + {totalHours} 小時</label>
                </div>
            </div>
          <div className="row m-t-16">
            <div className="col-12 col-pad-12">
              <label className="u-form__label text-align-right">審核備註：</label>
              <input required={true} value={notes} onChange={(e)=>{onChangeFunc('notes', e.target.value);}} className="u-form__input underline"/>
            </div>
          </div>

                  {/* <div className="col-12 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px', color:'red'}}>**打一段班卡請申請時請自行扣除休息時間。**</label>
                    </div>
                    <div className="col-12 col-pad-12">
                      <label className="u-form__label text-align-right" style={{flex: '0 0 54px', color:'red'}}>**打兩段班卡申請不需要在另外扣休息時間。**</label>
                    </div> */}
                    {
                      originTotalSec>=4*60*60 ? 
                      <div className="row">

                      <div className="col-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px', color:'red'}}>**勞動基準法第32條**</label>
                      </div>
      
                      <div className="col-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px', color:'red'}}>**雇主延長勞工之工作時間連同正常工作時間**</label>
                      </div>
  
                      <div className="col-12">
                        <label className="u-form__label text-align-right" style={{flex: '0 0 54px', color:'red'}}>**一日不得超過12小時**</label>
                      </div>
                    </div>
                      :<React.Fragment></React.Fragment>
                    }

          <div className="u-btn-group right">
            <button disabled={payType == '-1' ||typeof payType == "undefined"} className={payType == '-1' ||typeof payType == "undefined"?"btn btn-md disable":"btn btn-md save"}  onClick={(e) => {
              e.preventDefault();
              if((reason == null || reason.length == 0) && dropReason === '-1'){
                swal({
                  type: 'error',
                  title: '事由不可空白',
                  showConfirmButton: false,
                  showCloseButton: true,
                  heightAuto: false,
                  width: '250px'
                })
                return;
              }
              // 檢核的基準要跟送出的值一致：同一天的時分差
              if(!(overtimeMinutes > 0)){
                swal({
                  type: 'error',
                  title: '開始時間不可大於結束時間',
                  showConfirmButton: false,
                  showCloseButton: true,
                  heightAuto: false,
                  width: '250px'
                })
                return;
              }
              saveFunc(dropReason);
            }}>送出</button>
            <button className="btn btn-md cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleFunc();
              }
            }>取消</button>
          </div>
        </form>
      </div>
    </div>
  )

}

export default ProxyOvertime;